module.exports = __webpack_public_path__ + "media/哈哈.f2c7a268.mp3";